import { Heading, Text } from "@chakra-ui/react";

interface Props {
  heading: string;
  description: string;
}

function AuthPagesHeader({ heading, description }: Props) {
  return (
    <>
      <Heading fontSize="2xl">{heading}</Heading>
      <Text>{description}</Text>
    </>
  );
}

export default AuthPagesHeader;
